module.exports = __webpack_public_path__ + "img/sfondo-risotto-alla-milanese.b3fc435d.png";